"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const Container = styled_1.default.div({
    label: "progress",
    overflowX: "hidden",
    textAlign: "center",
}, ({ theme, bottom, inline, width }) => (Object.assign({}, (inline
    ? {
        backgroundColor: theme.color.background.light,
        borderRadius: theme.borderRadius,
        width: width ? width : "100%",
        minWidth: 64,
    }
    : {
        backgroundColor: "transparent",
        position: "fixed",
        width: "100%",
        top: bottom ? "auto" : 0,
        bottom: bottom ? 0 : "auto",
        left: 0,
    }), { zIndex: theme.zIndex.globalProgress })));
const fillProgress = core_1.keyframes({
    from: {
        transform: "translate3d(-100%, 0, 0)",
    },
    to: {
        transform: "translate3d(0, 0, 0)",
    },
});
const Bar = styled_1.default.div(({ percentage, theme }) => (Object.assign({ width: "100%", height: 3, position: "relative" }, (typeof percentage !== "undefined"
    ? {
        ":after": {
            content: `""`,
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: theme.color.primary,
            width: `${percentage}%`,
            height: "100%",
        },
    }
    : {
        animation: `${fillProgress} cubic-bezier(0, 0.9, 0.26, 1) forwards 20s`,
        backgroundColor: theme.color.primary,
    }))));
const Progress = (_a) => {
    var { onRetry, onClose, percentage } = _a, props = __rest(_a, ["onRetry", "onClose", "percentage"]);
    return (React.createElement(Container, Object.assign({}, props),
        React.createElement(Bar, { percentage: percentage })));
};
exports.default = Progress;
exports.FixedProgress = styled_1.default(Progress) `
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
`;
//# sourceMappingURL=Progress.js.map